<template>
	<div id="moduleAppList">
		<div class="top">
			<el-button size="medium" type="primary" @click="dialogFormVisible = true">新建模块</el-button>
			<el-input size="medium" class="search-input search-input--right" placeholder="模块名称" v-model="searchName" @keyup.enter.native="getList">
				<el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
			</el-input>
		</div>
		<div>
			<el-table :height="windowHeight - 210" :data="dataList" style="width: 100%" border>
				<el-table-column label="模块名称" align="center">
					<template slot-scope="scope">
						<span
							class="link"
							@click="
								$router.push({
									path: 'userManualList',
									query: {
										moduleHelpId: scope.row.id
									}
								})
							"
						>
							{{ scope.row.name }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="绑定系统应用" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.moduleName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="排序" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.orderNo }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="是否公开" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.publicShow === 0 ? '不公开' : '公开' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="editMoudleData(scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="deleteModuleHelpById(scope.row.id)">删除</el-button>
						<el-button type="text" size="small" v-if="scope.row.publicShow === 1" @click="showModuleHelpById(scope.row.id, scope.row.publicShow)">取消公开</el-button>
						<el-button type="text" size="small" v-if="scope.row.publicShow === 0" @click="showModuleHelpById(scope.row.id, scope.row.publicShow)">公开</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog :title="isAdd ? '新增模块':'编辑模块'" :visible.sync="dialogFormVisible" @close="closeDialog" :show-close="false">
				<el-form :model="formData" :rules="rules" ref="ruleForm">
					<el-form-item label="模块名称" :label-width="formLabelWidth" prop="name">
						<el-input v-model="formData.name" autocomplete="off" style="width: 70%" maxlength="12" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="绑定系统应用" :label-width="formLabelWidth" prop="moduleCode">
						<el-select v-model="formData.moduleCode" filterable placeholder="请选择" @change="moduleChange">
							<el-option label="无绑定" :value="0"></el-option>
							<el-option v-for="item in moduleList" :key="item.code" :label="item.name" :value="item.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="排序" :label-width="formLabelWidth" prop="order">
						<el-input-number v-model="formData.orderNo" :step="1" step-strictly :min="0" label="描述文字"></el-input-number>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="addModules">确 定</el-button>
				</div>
			</el-dialog>
			<div class="pagination-container">
				<el-pagination @size-change="sizeChangeHandler" @current-change="currentChangeHandler" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size.sync="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :page-count="pagination.pages" :total="pagination.total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { schoolTypeConstants } from '@/utils/constants'
import { parseToConstants, isShowByPermission } from '@/utils/utils'

import windowResize from '@/mixins/windowResize'
import baseMixin from '@/mixins/baseMixin'
import { insertModuleHelp, queryModuleHelp, queryModuleList, deleteModuleHelpById, showModuleHelpById, editModuleHelp } from '@/api/userManual'

export default {
	name: 'subjectList',
	data() {
		return {
			editId: '',
			isAdd: true,
			formData: {
				name: '',
				moduleCode: '',
				orderNo: 0,
				moduleName: ''
			},
			pagination: {
				pageNo: 1,
				pageSize: 10,
				total: 0
			},
			rules: {
				name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }],
				moduleCode: [{ required: true, message: '请选择绑定系统应用', trigger: 'blur' }],
				orderNo: [{ required: true, message: '请输入排序', trigger: 'change' }]
			},
			moduleList: [],
			dialogFormVisible: false,
			searchName: '',
			dataList: [],
			multipleSelection: [],
			level: '0',
			schoolTypeConstants,
			formLabelWidth: '120px'
		}
	},
	filters: {
		timeFormat(time) {
			return time ? time.substring(0, 19) : ''
		}
	},
	created() {
		this.queryModuleList()
		this.queryModuleHelp()
	},
	computed: {
		getTitle() {
			return this.isAdd ? '新增':'编辑'
		}
	},
	// beforeRouteEnter(to, from, next) {
	// 	next(vm => {
	// 		vm.queryModuleHelp()
	// 	})
	// },
	mixins: [windowResize, baseMixin],
	methods: {
		editMoudleData(item) {
			this.isAdd = false
			this.formData.moduleName = item.moduleName
			this.formData.name = item.name
			this.formData.moduleCode = item.moduleCode
			this.formData.orderNo = item.orderNo
			this.dialogFormVisible = true
			this.editId = item.id
		},
		showModuleHelpById(id, publicShow) {
			let text = ''
			let show = ''
			if (publicShow === 0) {
				show = 1
				text = '公开'
			} else {
				show = 0
				text = '不公开'
			}
			this.$confirm(`此操作会将该模块设为${text}, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					showModuleHelpById({ id: id, publicShow: show }).then(res => {
						this.queryModuleHelp()
						this.$message({
							type: 'success',
							message: '操作成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					})
				})
		},
		deleteModuleHelpById(id) {
			this.$confirm('此操作将永久删除该模块, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteModuleHelpById({ id: id }).then(res => {
						this.queryModuleHelp()
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		moduleChange(val) {
			this.formData.moduleName = this.moduleList.find(v => {
				return val === v.code
			}).name
		},
		queryModuleList() {
			queryModuleList().then(res => {
				this.moduleList = res
			})
		},

		closeDialog() {
			this.$refs.ruleForm.clearValidate()
			this.$nextTick(() => {
				this.formData.moduleName = ''
				this.formData.name = ''
				this.formData.moduleCode = ''
				this.formData.orderNo = 0
				this.editId = ''
				this.isAdd = true
			})
		},
		addModules() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					if (this.formData.moduleCode === 0) {
						this.formData.moduleName = '无绑定'
					}
					new Promise(resove => {
						if (this.isAdd) {
							insertModuleHelp(this.formData).then(resove)
						} else {
							editModuleHelp({ ...this.formData, id: this.editId }).then(resove)
						}
					}).then(res => {
						this.queryModuleHelp()
						this.$message({
							message: '操作成功！',
							type: 'success'
						})
						this.$nextTick(() => {
							this.formData.moduleName = ''
							this.formData.name = ''
							this.formData.moduleCode = ''
							this.formData.orderNo = 0
							this.formData.editId = ''
							this.isAdd = true
						})
						this.dialogFormVisible = false
					})
				}
			})
		},
		isShowByPermission,
		parseToConstants,
		getList() {
			this.pagination.pageNo = 1
			setTimeout(() => {
				this.queryModuleHelp()
			}, 100)
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		sizeChangeHandler() {
			this.queryModuleHelp()
		},
		currentChangeHandler() {
			this.queryModuleHelp()
		},
		batchDeleteHandler() {
			if (this.multipleSelection.length === 0) {
				this.$message.error('请选择要删除的课程')
			} else {
				this.deleteHandler(this.multipleSelection.map(({ id }) => id).join(','))
			}
		},
		// deleteHandler(delIds) {
		// 	this.$confirm('确认要删除吗？', '删除', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning',
		// 		lockScroll: false
		// 	}).then(() => {
		// 		deleteCurriculum({
		// 			delIds
		// 		}).then(() => {
		// 			this.queryModuleHelp()
		// 		})
		// 	})
		// },
		async queryModuleHelp() {
			let data = await queryModuleHelp({
				searchName: this.searchName,
				pageNo: this.pagination.pageNo,
				pageSize: this.pagination.pageSize
			})
			this.dataList = data.data.data.dataList
			this.pagination.total = data.data.data.pagination.total
		}
	}
}
</script>
<style>
.courseLogo {
	width: 25px;
	height: 25px;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__headerbtn {
	top: 16px !important;
}
/deep/ .el-dialog__header  {
	line-height: 46px !important;
}
/deep/ .el-select {
	width: inherit !important;
}
/deep/ .el-dialog {
	width: 700px;
}
#moduleAppList {
	padding: 12px;

	.pagination-container {
		margin-top: 10px;
	}

	.top {
		padding-bottom: 10px;
		overflow: hidden;
	}

	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}

	.state-container {
		margin: 15px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/systemData/userManual/userManualIndex.vue